import { select, takeLatest, call, put } from 'redux-saga/effects';
// import { push } from 'react-router-redux';
import {
  _getPinForAuthorizeLoaded,
  _getPinForAuthorizeError,
  _registerPhoneError,
  _getCodeOfAuthorizeLoaded,
  _getCodeOfAuthorizeError,
  setPropsFormPinRequest,
  setPropsFormPhoneNumerRequest,
  setPropsFormRegisterRequest
  // _showMessageWithoutSubscription
} from './actions';

import {
  GET_PIN_FOR_AUTHORIZE,
  GET_CODE_OF_AUTHORIZE,
  EDIT_PHONE_NUMBER,
  MSG_PHONE_NUMBER_EMPTY,
  MSG_PHONE_NUMBER_INCONPLETE,
  MSG_PHONE_NUMBER_INVALID_TO_SEND_PIN,
  MSG_REGISTER_ERROR,
  MSG_PIN_NUMBER_EMPTY,
  MSG_PIN_INVALID,
  MSG_PIN_INCOMPLETE,
  REGISTER_PHONE,
  MSG_PIN_ERROR,
  MSG_RECAPTCHA_DATA_EMPTY,
  MSG_REGISTER_TIMEOUT,
} from './constants';

import {
  selectPhoneNumber,
  selectPinNumber,
  selectInitialDataConfig,
  selectSubscriptionPlan
} from './selectors';

import Oauth2Service from '../../services/Oauth2Service';


function* getPinForAuthorize(action) {
  try {
    const state = yield select();
    const initialConfig = selectInitialDataConfig(state);
    // eslint-disable-next-line
    const phoneNumber = selectPhoneNumber(state) ? selectPhoneNumber(state).toString().match(/\d+/g).toString().replace(',', '') : '';
    const recaptchaToken = action.data.token;

    if (!phoneNumber) {
      return yield put(_getPinForAuthorizeError({
        message: MSG_PHONE_NUMBER_EMPTY,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    if (phoneNumber.length !== 9) {
      return yield put(_getPinForAuthorizeError({
        message: MSG_PHONE_NUMBER_INCONPLETE,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    if (!recaptchaToken && action.data !== 'renew') {
      return yield put(_getPinForAuthorizeError({
        message: MSG_RECAPTCHA_DATA_EMPTY,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    if (action.data === 'renew') {
      return yield put(setPropsFormPhoneNumerRequest());
    }

    const oAuth2data = yield call(Oauth2Service.sendPin, phoneNumber, initialConfig.client_id, recaptchaToken);
    // const access = yield call(Oauth2Service.verifyAccess, phoneNumber, initialConfig.client_id);

    if (oAuth2data.code === 'CPT-001') {
      return yield put(_getPinForAuthorizeError({
        message: MSG_RECAPTCHA_DATA_EMPTY,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    if (oAuth2data.code === 'BITEL-204' /* && !access */) {
      return yield put(setPropsFormRegisterRequest());
    }
    
    if (oAuth2data.code !== 'BITEL-100' /* && oAuth2data.code !== 'BITEL-204' */) {
      return yield put(_getPinForAuthorizeError({
        message: MSG_PHONE_NUMBER_INVALID_TO_SEND_PIN,
        color: 'danger'
      }));
    }

    yield put(setPropsFormPinRequest());
    return yield put(_getPinForAuthorizeLoaded({ ok: true }));

  } catch (error) {

    return yield put(_getPinForAuthorizeError({
      message: 'Error encontrado',
      color: 'danger'
    }));

  }
}

function* registerPhone(action) {
  try {
    const state = yield select();
    const initialConfig = selectInitialDataConfig(state);
    // eslint-disable-next-line
    const phoneNumber = selectPhoneNumber(state) ? selectPhoneNumber(state).toString().match(/\d+/g).toString().replace(',', '') : '';
    const subscriptionPlan = selectSubscriptionPlan(state)
    const recaptchaToken = action.data.token;

    if (!phoneNumber) {
      return yield put(_registerPhoneError({
        message: MSG_PHONE_NUMBER_EMPTY,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    if (phoneNumber.length !== 9) {
      return yield put(_registerPhoneError({
        message: MSG_PHONE_NUMBER_INCONPLETE,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    if (!recaptchaToken) {
      return yield put(_getPinForAuthorizeError({
        message: MSG_RECAPTCHA_DATA_EMPTY,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    const oAuth2data = yield call(Oauth2Service.register, phoneNumber, subscriptionPlan, initialConfig, recaptchaToken);

    if (oAuth2data.code === 'CPT-001') {
      return yield put(_registerPhoneError({
        message: MSG_RECAPTCHA_DATA_EMPTY,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    if (oAuth2data.error === 'IDP-024') {
      return yield put(_registerPhoneError({
        message: MSG_REGISTER_TIMEOUT,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }
    
    if (oAuth2data.error_description != null || oAuth2data.error != null || oAuth2data.code == null) {
      return yield put(_getCodeOfAuthorizeError({
        message: MSG_PIN_ERROR,
        color: 'danger',
        ok: false
      }));
    }

    const hasState = initialConfig.state ? `&state=${initialConfig.state}` : '';
    const urlRedirect = `${initialConfig.redirect_uri}?code=${oAuth2data.code}${hasState}`;
    window.location.assign(`/redirect/${encodeURIComponent(urlRedirect)}`)

    return yield put(_getCodeOfAuthorizeLoaded());
  } catch (error) {
    return yield put(_registerPhoneError({
      message: MSG_REGISTER_ERROR,
      color: 'danger'
    }));

  }
}

/* ========================================================================
=            Function for consulting code to Oauth2/Authorize            =
========================================================================*/

function* getCodeOfAuthorize() {
  try {
    const state = yield select();
    const phoneNumber = selectPhoneNumber(state)
    .toString().match(/\d+/g).toString()
    .replace(',', '');
    const pinNumber = selectPinNumber(state) ? selectPinNumber(state).toString() : null;
    const config = selectInitialDataConfig(state);

    if (!pinNumber) {
      return yield put(_getCodeOfAuthorizeError({
        message: MSG_PIN_NUMBER_EMPTY,
        color: 'warning'
      }));
    }

    if (pinNumber.length !== 4) {
      return yield put(_getCodeOfAuthorizeError({
        message: MSG_PIN_INCOMPLETE,
        color: 'warning'
      }));
    }

    const data = {
      msisdn: phoneNumber,
      pin: pinNumber
    };

    const oAuth2data = yield call(Oauth2Service.authorize, config, data, false);

    if (oAuth2data.error === 'IDP-022') {
      return yield put(_getCodeOfAuthorizeError({
        message: MSG_PIN_INVALID,
        color: 'danger',
        ok: false
      }));
    }

    if (oAuth2data.error_description != null || oAuth2data.error != null || oAuth2data.code == null) {
      return yield put(_getCodeOfAuthorizeError({
        message: MSG_PIN_ERROR,
        color: 'danger',
        ok: false
      }));
    }

    const hasState = config.state ? `&state=${config.state}` : '';
    const urlRedirect = `${config.redirect_uri}?code=${oAuth2data.code}${hasState}`;
    window.location.assign(`/redirect/${encodeURIComponent(urlRedirect)}`)

    return yield put(_getCodeOfAuthorizeLoaded());

  } catch (e) {

    return yield put(_getCodeOfAuthorizeError({
      ok: false,
      message: 'Internal error',
      color: 'danger'
    }));
  }
}

function* _setPropsFormPhoneNumerRequest() {
  yield put(setPropsFormPhoneNumerRequest());
}

function* apiData() {
  yield takeLatest(GET_PIN_FOR_AUTHORIZE, getPinForAuthorize);
  yield takeLatest(REGISTER_PHONE, registerPhone);
  yield takeLatest(GET_CODE_OF_AUTHORIZE, getCodeOfAuthorize);
  yield takeLatest(EDIT_PHONE_NUMBER, _setPropsFormPhoneNumerRequest);
}

export default apiData;
